import { API_URL } from "../config/connect";
import { throwResponseError } from '../utils/apiErrorHandler';

const CACHE_TTL_MS = 30_000;
let cached = null;

const getHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem("access_token")}`,
});

export function bustFavoritesCache() {
    cached = null;
}

async function getUserFavorites() {
    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            return;
        }

        if (cached && Date.now() - cached.ts < CACHE_TTL_MS) {
            return cached.data;
        }

        const response = await fetch(`${API_URL}/api/v1/favorites`, {
            method: 'GET',
            headers: getHeaders(),
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        const data = await response.json();
        cached = { data, ts: Date.now() };
        return data;
    } catch (error) {
        console.error("Error in getUserFavorites:", error);
        throw error;
    }
}

async function addToFavorites(announcementId) {
    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            return;
        }

        const response = await fetch(`${API_URL}/api/v1/favorites/${announcementId}`, {
            method: 'POST',
            headers: getHeaders(),
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        bustFavoritesCache();
        return await response.json();
    } catch (error) {
        console.error("Error in addToFavorites:", error);
        throw error;
    }
}

async function removeFromFavorites(announcementId) {
    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            return;
        }

        const response = await fetch(`${API_URL}/api/v1/favorites/${announcementId}`, {
            method: 'DELETE',
            headers: getHeaders(),
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        bustFavoritesCache();
        return await response.json();
    } catch (error) {
        console.error("Error in removeFromFavorites:", error);
        throw error;
    }
}

async function getFavoriteStatus(announcementId) {
    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            return;
        }

        const response = await fetch(`${API_URL}/api/v1/favorites/${announcementId}/status`, {
            method: 'GET',
            headers: getHeaders(),
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in getFavoriteStatus:", error);
        throw error;
    }
}

export { getUserFavorites, addToFavorites, removeFromFavorites, getFavoriteStatus };